import React, { useContext, useRef, useState } from 'react';

import { Box, Button, Fab, Stack } from '@mui/material';

import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

import Axios from '../../../Assets/Axios/Axios';

import ToastContext from '../../../Context/ToastContext';
import { useAuthContext } from '../../../Context/AuthContext';

import { ORDER_STATUS } from './../../../Constant/Enums';

import { TypoPoppBlue, TypoPoppins } from '../../../Components/Typo';

import CustomCard from './CustomCard';

import { UpdateOrderStatus } from '../../../Server/Mutation/index';

import useProfessionalOrders from './useProfessionalOrders';
import { dummyOrdersData } from '../../../lib/DummyData/professionalPage';

const JobInformationInCompleteSection = () => {

  const orders = dummyOrdersData;
const updateOrders = () => {}; // no-op for dummy


  // const { user } = useAuthContext();
  const { showToastMessage } = useContext(ToastContext);

  // const { orders, updateOrders } = useProfessionalOrders(ORDER_STATUS.ACCEPTED, user.userID);
  const [isScrollTopVisible, setIsScrollTopVisible] = useState(false);

  const scrollableContainer = useRef();

  /**
   * @param{"COMPLETE" | "CANCEL"} action
   * @param{string} orderUniqueID
   */
  // const handleClickActions = async (action, orderUniqueID) => {
  //   if (typeof orderUniqueID === 'undefined' || orderUniqueID === null) return;
  //   const orderStatus = action === 'COMPLETE' ? ORDER_STATUS.COMPLETED : ORDER_STATUS.CANCELLED;

  //   const query = UpdateOrderStatus({ orderStatus, orderUniqueID });
  //   const { errors } = await Axios({ query });

  //   if (errors) {
  //     showToastMessage('Oops! Something went wrong!');
  //     return undefined;
  //   }

  //   showToastMessage('Job Updated Successfully', 'success');
  //   updateOrders();
  // };

  function handleScrollTopVisibility(event) {
    const shouldScrollTopVisible = event.currentTarget.scrollTop > 100;
    if (shouldScrollTopVisible !== isScrollTopVisible)
      setIsScrollTopVisible(shouldScrollTopVisible);
  }

  function handleScrollTop() {
    scrollableContainer.current?.scrollTo({ top: 0, behavior: 'smooth' });
  }

  return (
    <>
      <Box position='relative' mt={4} width='fit-content' mx={{ xs: 'auto', md: 'initial' }}>
        <Stack
          gap={3}
          maxHeight={500}
          overflow='auto'
          px={2}
          pb={2}
          onScroll={handleScrollTopVisibility}
          ref={scrollableContainer}>
          {orders.map(cardProps => (
            <Box maxWidth={550} key={cardProps.referenceId}>
              <CustomCard
                data={{ ...cardProps, jobId: cardProps.id }}
                // actions={<CardActions onClickActions={handleClickActions} id={cardProps.id} />}
                {...cardProps}
              />
            </Box>
          ))}
        </Stack>

        {isScrollTopVisible && (
          <Fab
            size='small'
            sx={{ position: 'absolute', right: '16px', bottom: '8px' }}
            onClick={handleScrollTop}>
            <ArrowUpwardIcon />
          </Fab>
        )}
      </Box>

      {orders?.length === 0 && (
        <TypoPoppins
          fontWeight={400}
          color='text.secondary'
          variant='h6'
          variantMapping={{ h6: 'p' }}>
          No Pending Jobs Found
        </TypoPoppins>
      )}
    </>
  );
};

function CardActions({ onClickActions, id }) {
  return (
    <Box display='grid' gap={1} gridTemplateColumns='repeat(2,1fr)'>
      <Button color='blue' fullWidth onClick={() => onClickActions('COMPLETE', id)}>
        <TypoPoppins color='white' fontWeight={500} whiteSpace='nowrap'>
          Complete
        </TypoPoppins>
      </Button>

      <Button
        variant='outlined'
        color='blue'
        fullWidth
        onClick={() => onClickActions('CANCEL', id)}>
        <TypoPoppBlue fontWeight={500} whiteSpace='nowrap'>
          Event Cancel
        </TypoPoppBlue>
      </Button>
    </Box>
  );
}

export default JobInformationInCompleteSection;
